var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSBilletera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 228,
    viewBox: "0 0 261 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6 46.1H233.6C238 46.1 241.9 47.8 244.8 50.7C247.5 53.6 249.4 57.4 249.4 61.8V94.1V95.2H248.2H181.2C175.7 95.2 170.5 97.5 166.8 101.2C163.1 104.9 160.9 109.9 160.9 115.6V157.8C160.9 163.5 163.2 168.5 166.8 172.2C170.5 175.9 175.6 178.3 181.2 178.3H248.3H249.5V179.3V211.6C249.5 215.8 247.6 219.8 244.9 222.7C242 225.5 238 227.3 233.7 227.3H15.7C11.4 227.3 7.39998 225.4 4.59998 222.7C1.69998 219.8 0 215.8 0 211.6V61.8C0 57.4 1.69998 53.6 4.59998 50.7C7.29998 47.8 11.3 46.1 15.6 46.1ZM181.2 106.6H252C256.9 106.6 261 110.6 261 115.6V157.8C261 162.7 256.9 166.8 252 166.8H181.2C176.3 166.8 172.2 162.7 172.2 157.8V115.6C172.2 110.6 176.3 106.6 181.2 106.6ZM197.5 120.9C206.2 120.9 213.3 128 213.3 136.8C213.3 145.5 206.2 152.6 197.5 152.6C188.7 152.6 181.5 145.5 181.5 136.8C181.6 128 188.7 120.9 197.5 120.9ZM52.6 36.7C101.3 24.4 150 12.2 198.7 0C202.8 0.1 205.8 2 207.6 5.4C210.2 15.8 213 26.3 215.7 36.7C161.3 36.7 106.9 36.7 52.6 36.7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSBilletera);
export default __webpack_public_path__ + "static/media/SBilletera.af38a9c4.svg";
export { ForwardRef as ReactComponent };